/** 搜索快捷键在输入框内可用；排除输入法、AltGraph及额外组合键。 */
const unsafe=(event:KeyboardEvent)=>event.isComposing || event.keyCode===229 || event.shiftKey || event.getModifierState?.('AltGraph')
export function isFunctionSearchShortcut(event:KeyboardEvent,acceptRepeat=false):boolean {
  if(unsafe(event) || event.repeat && !acceptRepeat)return false
  const key=event.key.toLowerCase()
  return key==='q' && event.altKey && !event.ctrlKey && !event.metaKey
    || key==='k' && !event.altKey && event.ctrlKey!==event.metaKey
}
export function isAllOrdersShortcut(event:KeyboardEvent,acceptRepeat=false):boolean {
  return !unsafe(event) && (acceptRepeat || !event.repeat) && event.key.toLowerCase()==='w'
    && event.altKey && !event.ctrlKey && !event.metaKey
}
